import Logo from "../images/main_logo.png";

// Boostrap Imports
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import "bootstrap/dist/css/bootstrap.min.css";

// React Router
import { Link } from "react-scroll";

function UpdatedNavBar() {
  return (
    <Navbar
      expand="lg"
      style={{
        backgroundColor: "rgba(40, 32, 77, 0.20)",
      }}
      data-bs-theme="light"
      fixed="top"
    >
      <Container>
        <Navbar.Brand href="/">
          <img
            alt=""
            src={Logo}
            width="60"
            className="d-inline-block align-top"
          />{" "}
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav>
            <Nav.Link style={{ cursor: "pointer" }} href="/">
              ABOUT
            </Nav.Link>
            <Nav.Link style={{ cursor: "pointer" }} href="/">
              EVENTS
            </Nav.Link>
            <Nav.Link style={{ cursor: "pointer" }} href="/">
              GALLERY
            </Nav.Link>
            <Nav.Link style={{ cursor: "pointer" }} href="/#program">
              PROGRAM
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default UpdatedNavBar;
